import {Injectable} from "@angular/core";
import {VisbosService} from "../graphql/visbos.service";
import {Apollo, ApolloQueryObservable} from "apollo-angular";
import {Unit, UNIT_CATEGORY} from "../model/unit.type";
import gql from "graphql-tag";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../../../shared/redux-store";
import {SessionActions} from "../../../shared/actions";
import {map} from "rxjs/operators";

@Injectable()
export class UnitService extends VisbosService {

  constructor(apollo: Apollo, ngRedux: NgRedux<IAppState>, sessionActions: SessionActions) {
    super(apollo, ngRedux, sessionActions);
  }

  public getUnits(unitCategories?: UNIT_CATEGORY[]): ApolloQueryObservable<Unit[]> {

    let query = this.fetchItems<Unit[]>({
      query: gql`query FetchUnitsQuery($categories: [String]) {
        units(categories: $categories) {
          cuid, unit, label, unit_name, unit_category
        }
      }`,
      variables: {
        categories: unitCategories ? unitCategories : null
      }
    });

    return <ApolloQueryObservable<Unit[]>>query.pipe(map(({data}:any) => data.units));
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/services/unit.service.ts